import { categoryMeta } from '@/mocks/articles';

interface CategoryHeaderProps {
  slug: string;
}

export default function CategoryHeader({ slug }: CategoryHeaderProps) {
  const meta = categoryMeta[slug];
  const displayName = meta?.name || slug;
  const displayDesc = meta?.description || '浏览该分类下的所有吃瓜内容';
  const icon = meta?.icon || 'ri-file-list-line';

  return (
    <section className="relative w-full h-[300px] md:h-[380px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-900"></div>
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-primary-500/30 blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-accent-500/20 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-500 flex items-center justify-center mb-5">
          <i className={`${icon} text-foreground-950 text-2xl md:text-3xl w-7 h-7 md:w-8 md:h-8 flex items-center justify-center`}></i>
        </div>
        <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 text-center">
          {displayName}
        </h1>
        <p className="mt-4 text-sm md:text-base text-background-50/60 text-center max-w-xl leading-relaxed">
          {displayDesc}
        </p>
      </div>
    </section>
  );
}